"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Settings__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        inputs: [],
        name: "PER_BILL",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "PER_MILL",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "PER_TRILL",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "ZERO_ADDRESS",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "disputeManager",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "eraManager",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getDisputeManager",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getEraManager",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getIndexerRegistry",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getInflationController",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getPermissionedExchange",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getPlanManager",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getQueryRegistry",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getRewardsDistributer",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getRewardsHelper",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getRewardsPool",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getRewardsStaking",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getSQToken",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getServiceAgreementRegistry",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getStaking",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getStakingManager",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getStateChannel",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getVesting",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "indexerRegistry",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "inflationController",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "permissionedExchange",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "planManager",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "queryRegistry",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "rewardsDistributer",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "rewardsHelper",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "rewardsPool",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "rewardsStaking",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "serviceAgreementRegistry",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_disputeManager",
                type: "address",
            },
        ],
        name: "setDisputeManager",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_eraManager",
                type: "address",
            },
        ],
        name: "setEraManager",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_indexerRegistry",
                type: "address",
            },
        ],
        name: "setIndexerRegistry",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_inflationController",
                type: "address",
            },
        ],
        name: "setInflationController",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_permissionedExchange",
                type: "address",
            },
        ],
        name: "setPermissionedExchange",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_planManager",
                type: "address",
            },
        ],
        name: "setPlanManager",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_indexerRegistry",
                type: "address",
            },
            {
                internalType: "address",
                name: "_queryRegistry",
                type: "address",
            },
            {
                internalType: "address",
                name: "_eraManager",
                type: "address",
            },
            {
                internalType: "address",
                name: "_planManager",
                type: "address",
            },
            {
                internalType: "address",
                name: "_serviceAgreementRegistry",
                type: "address",
            },
            {
                internalType: "address",
                name: "_disputeManager",
                type: "address",
            },
            {
                internalType: "address",
                name: "_stateChannel",
                type: "address",
            },
        ],
        name: "setProjectAddresses",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_queryRegistry",
                type: "address",
            },
        ],
        name: "setQueryRegistry",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_rewardsDistributer",
                type: "address",
            },
        ],
        name: "setRewardsDistributer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_rewardsHelper",
                type: "address",
            },
        ],
        name: "setRewardsHelper",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_rewardsPool",
                type: "address",
            },
        ],
        name: "setRewardsPool",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_rewardsStaking",
                type: "address",
            },
        ],
        name: "setRewardsStaking",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_sqToken",
                type: "address",
            },
        ],
        name: "setSQToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_serviceAgreementRegistry",
                type: "address",
            },
        ],
        name: "setServiceAgreementRegistry",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_staking",
                type: "address",
            },
        ],
        name: "setStaking",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_stakingManager",
                type: "address",
            },
        ],
        name: "setStakingManager",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_stateChannel",
                type: "address",
            },
        ],
        name: "setStateChannel",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_sqToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "_staking",
                type: "address",
            },
            {
                internalType: "address",
                name: "_stakingManager",
                type: "address",
            },
            {
                internalType: "address",
                name: "_rewardsDistributer",
                type: "address",
            },
            {
                internalType: "address",
                name: "_rewardsPool",
                type: "address",
            },
            {
                internalType: "address",
                name: "_rewardsStaking",
                type: "address",
            },
            {
                internalType: "address",
                name: "_rewardsHelper",
                type: "address",
            },
            {
                internalType: "address",
                name: "_inflationController",
                type: "address",
            },
            {
                internalType: "address",
                name: "_vesting",
                type: "address",
            },
            {
                internalType: "address",
                name: "_permissionedExchange",
                type: "address",
            },
        ],
        name: "setTokenAddresses",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_vesting",
                type: "address",
            },
        ],
        name: "setVesting",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "sqToken",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "staking",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "stakingManager",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "stateChannel",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "vesting",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class Settings__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
        this.contractName = "Settings";
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.Settings__factory = Settings__factory;
Settings__factory.bytecode = _bytecode;
Settings__factory.abi = _abi;
